import React, { useEffect, useState } from "react";

// Romanian first, then a world tour of greetings.
const greetings = [
  "Buna",        // Romanian
  "Hello",        // English
  "Bonjour",      // French
  "Hola",         // Spanish
];

const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  window.matchMedia &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const TYPE_MS = 85;   // time to type each character
const HOLD_MS = 450;  // pause on the fully-typed word before the next one

const Loader = ({ onReveal, onComplete }) => {
  const [typed, setTyped] = useState("");
  const [leaving, setLeaving] = useState(false);

  // Kick off the wipe AND reveal the app underneath at the same moment,
  // so the About section is already fading in as the loader slides away.
  const startExit = () => {
    setLeaving(true);
    onReveal && onReveal();
  };

  useEffect(() => {
    const reduced = prefersReducedMotion();

    // With reduced motion: show one greeting fully, then exit — no typing/flicker.
    if (reduced) {
      setTyped(greetings[0]);
      const exitTimer = setTimeout(startExit, 700);
      const doneTimer = setTimeout(() => onComplete && onComplete(), 1100);
      return () => {
        clearTimeout(exitTimer);
        clearTimeout(doneTimer);
      };
    }

    const timers = [];
    let elapsed = 0;

    greetings.forEach((word) => {
      // Type the word out one character at a time.
      for (let c = 1; c <= word.length; c += 1) {
        const at = elapsed + c * TYPE_MS;
        timers.push(
          setTimeout(() => setTyped(word.slice(0, c)), at)
        );
      }
      elapsed += word.length * TYPE_MS + HOLD_MS;
    });

    // After the last greeting, trigger the wipe + app reveal together,
    // then unmount the loader once the wipe finishes.
    timers.push(setTimeout(startExit, elapsed + 100));
    timers.push(setTimeout(() => onComplete && onComplete(), elapsed + 860));

    return () => timers.forEach(clearTimeout);
  }, [onReveal, onComplete]);

  return (
    <div
      className={`loader ${leaving ? "loader--leaving" : ""}`}
      role="status"
      aria-live="polite"
      aria-label="Loading portfolio"
    >
      <span className="loader-word">
        {typed}
        <span className="loader-cursor" aria-hidden="true"></span>
      </span>
    </div>
  );
};

export default Loader;
